/* eslint-disable react/jsx-indent */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Card, CardBody, Button, Spinner } from 'reactstrap'
import moment from 'moment'
import {MaterialReactTable} from 'material-react-table'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import oikosApi from '../../../services/oikos';
import powerappsApi from '../../../services/powerapps';
import qs from 'qs';
import ModalEdicaoContaAPagar from './ModalEdicaoContaAPagar';
import ModalAddContaAPagar from './ModalAddContaAPagar'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import ModalDeleteBordero from './ModalDeleteBordero'
import { selectValues } from '../../../utils/fc'
import { Publish } from '@material-ui/icons';
import { Modal, Typography } from '@mui/material'
import AddFilesNoForm from '../../../components/Template/Files/AddFilesNoForm';
import ModalConfirmacao from '../../../components/Modals/ModalConfirmacao/ModalConfirmacao'
import ModalOikosDocsViewer from '../../../components/Modals/ModalOikosDocsViewer/ModalOikosDocsViewer'
import { notifySuccess, notifyError } from '../../../utils/notify'
import { currencyFormatter } from '../../../utils/currencyFormatter'
import { getBackendUrls } from '../../../config/backendEnv'

const FILE_BASE = 'https://oikos.ecoss.is/oikos/'

const activeFilesBase = () => {
  const api = getBackendUrls().oikos || FILE_BASE
  return api.replace(/_oikos_api\.php.*$/, '')
}

const STATUS_COLORS = {
  ok: '#16a34a',      // presente
  info: '#2563eb',    // dispensado
  missing: '#94a3b8', // faltando
}

const statusIconStyle = (tone) => ({
  color: STATUS_COLORS[tone] || STATUS_COLORS.missing,
  fontSize: 18,
  lineHeight: 1,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
})

const StatusIcon = ({ iconClass, tone, title, href, uploadNode }) => {
  const icon = (
    <i
      className={iconClass}
      style={statusIconStyle(tone)}
      title={title}
    />
  )

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        title={title}
        onClick={(e) => e.stopPropagation()}
        style={{ display: 'inline-flex', lineHeight: 1 }}
      >
        {icon}
      </a>
    )
  }

  if (uploadNode) {
    return (
      <span
        className="d-inline-flex align-items-center"
        title={title}
        style={{ lineHeight: 1 }}
        onClick={(e) => e.stopPropagation()}
      >
        {uploadNode}
      </span>
    )
  }

  return icon
}

const BorderoDocsInline = ({
  keys_signals,
  canUpload,
  notaFiscalUpload,
  docCobrancaUpload,
  onOpenViewer,
}) => {
  const {
    documento_id_doc_cobranca,
    documento_id_nota_fiscal,
    documento_id_comprovante,
    kamino_id,
    bdro_dispNF,
    bdro_dispDocCobranca,
  } = keys_signals || {}

  const nfTone = documento_id_nota_fiscal
    ? 'ok'
    : Number(bdro_dispNF) === 1
      ? 'info'
      : 'missing'
  const cobTone = documento_id_doc_cobranca
    ? 'ok'
    : Number(bdro_dispDocCobranca) === 1
      ? 'info'
      : 'missing'
  const bancoTone = kamino_id ? 'ok' : 'missing'

  return (
    <div
      className="d-flex align-items-center"
      style={{ gap: 8, minHeight: 24 }}
    >
      <StatusIcon
        iconClass="ri-bill-line"
        tone={nfTone}
        title={
          nfTone === 'ok'
            ? 'Nota fiscal: presente'
            : nfTone === 'info'
              ? 'Nota fiscal: dispensada'
              : 'Nota fiscal: faltando'
        }
        href={documento_id_nota_fiscal ? `${FILE_BASE}${documento_id_nota_fiscal}` : null}
        uploadNode={
          canUpload && nfTone === 'missing' ? notaFiscalUpload : null
        }
      />
      <StatusIcon
        iconClass="ri-barcode-box-line"
        tone={cobTone}
        title={
          cobTone === 'ok'
            ? 'Documento de cobrança: presente'
            : cobTone === 'info'
              ? 'Documento de cobrança: dispensado'
              : 'Documento de cobrança: faltando'
        }
        href={documento_id_doc_cobranca ? `${FILE_BASE}${documento_id_doc_cobranca}` : null}
        uploadNode={
          canUpload && cobTone === 'missing' ? docCobrancaUpload : null
        }
      />
      {(kamino_id || documento_id_comprovante) && (
        <StatusIcon
          iconClass="ri-receipt-line"
          tone={documento_id_comprovante ? 'ok' : 'missing'}
          title={
            documento_id_comprovante
              ? 'Comprovante de pagamento'
              : 'Comprovante da Kamino: ainda sem arquivo'
          }
          href={documento_id_comprovante ? `${activeFilesBase()}${documento_id_comprovante}` : null}
        />
      )}
      <StatusIcon
        iconClass="ri-bank-line"
        tone={bancoTone}
        title={
          bancoTone === 'ok'
            ? 'Enviado para o banco'
            : 'Não enviado para o banco'
        }
      />
      {onOpenViewer && (
        <button
          type="button"
          title="Visualizar PDFs do registro"
          onClick={(e) => {
            e.stopPropagation()
            onOpenViewer()
          }}
          style={{
            border: 0,
            background: 'transparent',
            padding: 0,
            lineHeight: 1,
            cursor: 'pointer',
          }}
        >
          <i className="ri-file-search-line" style={statusIconStyle('info')} />
        </button>
      )}
    </div>
  )
}

const denseBodyCellSx = {
  fontSize: '12px',
  py: '4px',
  px: '8px',
  maxWidth: 'none',
  verticalAlign: 'middle',
}

const denseHeadCellSx = {
  fontSize: '11px',
  fontWeight: 600,
  py: '4px',
  px: '8px',
  maxWidth: 'none',
}

class Bordero extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dataNaoPend: false,
      dataPend: false,
      exibirParcelasCartao: false,
      categories: false,
      dataIsLoading: false,
      pqGridViewIsOpen: false,
      dropdownOpenRow: null,
      specificProduct: {},
      specificProductIsLoading: false,

      refreshComponent: 0,
      editProjectTeamDialogIsOpen: false,
      editProjectTeamPeople: [],

      addProductModalIsOpen: false,
      addProductData: {},

      addActivityModalIsOpen: false,
      addActivityData: {},

      addDocumentModalIsOpen: false,
      addMailModalIsOpen: false,

      getDocumentsIsLoading: false,
      documents: [],

      documentsProducts: [],

      emailData: {},

      selTpStatus: false,

      productsOfProject: {},
      productDetails: {},
      loadingRows: [],

      emptyValues: [],

      isModalOpen: true,
      openErrorModal: false,
      salvarAnexoModalIsOpen: false,

      notaFiscalFile: [],
      pendingNotaFiscalFile: null,  // TEMP file waiting confirmation

      documentoCobrancaFile: [],
      pendingDocumentoCobrancaFile: null,  // TEMP file waiting confirmation

      borderoSendingToKamino: null,
      publishConfirmModalOpen: false,
      publishModalData: null,
      publishModalLoading: false,

      docsViewerOpen: false,
      docsViewerRecord: null,
      bdroDropRowId: null,
      bdroDraggingId: null,
      bdroMoving: false,
    };
    this.onFilesChangeNF = this.onFilesChangeNF.bind(this);
    this.onFilesChangeDocCobranca = this.onFilesChangeDocCobranca.bind(this);
  }

  onFilesChangeNF = (file) => {
    console.log('file', file);
    this.setState({ pendingNotaFiscalFile: file, salvarAnexoModalIsOpen: true });
  }

   onFilesChangeDocCobranca = (file) => {
    console.log('file', file);
    this.setState({ pendingDocumentoCobrancaFile: file, salvarAnexoModalIsOpen: true });
  }

  setDocumentoCobrancaFile = (file) => {
    this.setState({ documentoCobrancaFile: file });
  }

  handleOpenErrorModal = () => {
    this.setState({ openErrorModal: true });
  }

  handleCloseErrorModal = () => {
    this.setState({ openErrorModal: false, emptyValues: [] });
  };

  getCategories = async () => {
    const in_txt = `!IN!(SELECT categ_id FROM categ WHERE categ_id IN (SELECT categ_id FROM orcItem WHERE orcRubr_id IN (SELECT id_oikos FROM viewOrcRubr_taxonomia2 WHERE nivel3_id = ${this.props.proj_orcRubrId})))`;
    const resTodasAsCategorias = await selectValues('categ', 'categ_id', 'categ_nome', { categ_ativo: 1, categ_id: in_txt });
    const sortedTodasAsCategorias = resTodasAsCategorias.sort((a, b) => a.label.localeCompare(b.label));
    this.setState({ categories: sortedTodasAsCategorias });
  }

  conciliaKaminoBdro = async () => {
    const res = await powerappsApi.post('/', { acao: 'kamino_conciliar_bdro' }, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        }});
    console.log(res);
  }

  componentDidMount() {
    console.log(this.props);
    this.preloading();
    if (this.props.proj_orcRubrId) {
      this.getCategories();
    }
  }

  preloading = async () => {
    this.setState({ dataIsLoading: true, dataNaoPend: [], dataPend: [] });
    await this.conciliaKaminoBdro();
    const today = new Date();

    const inicio = this.formatDate(this.firstDayOfPreviousMonth(today));
    const fim   = this.formatDate(this.lastDayOfNextMonth(today));

    await this.getBdroRecords({inicio, fim});
    await this.getAccounts();
    this.setState({dataIsLoading: false });
  }

  getAccounts = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: "get",
        table: "conta",
        data: {
        },
        fields: {
        },
      })}`
    );
    this.setState({accounts: res.data });
  }

  firstDayOfPreviousMonth(date) {
    return new Date(
      date.getFullYear(),
      date.getMonth() - 1,
      1
    );
  }

  lastDayOfNextMonth(date) {
    return new Date(
      date.getFullYear(),
      date.getMonth() + 2,
      0 // day 0 = last day of previous month
    );
  }

  formatDate(date) {
    return date.toISOString().split('T')[0];
  }

  //Essa função envia todos os borderôs que estão agregados em uma linha para a kamino:
  enviarBorderosParaOBanco = async (listaBorderos, rowId) => {

    console.log('rowId', rowId);

    let breakOutsideFor = false;

    for (let index = 0; index < listaBorderos.length; index++) {

      const b = listaBorderos[index];
      this.setState({borderoSendingToKamino: rowId});

      if (b.original.keys_signals.kamino_id || breakOutsideFor) {
        continue;
      }
      const emptyValues= [];
      const data = {
        bdro_id: b.original.bdro_id,
        bdro_dtVenc: moment(b.original.bdro_dtVenc).format('YYYY-MM-DD'),
        ...(b.original.bdro_dtQuit ? { bdro_dtQuit: ((moment(b.original.bdro_dtQuit).format('YYYY-MM-DD') === "Data inválida") || (moment(b.original.bdro_dtQuit).format('YYYY-MM-DD') === "Invalid date")) ? undefined : moment(b.original.bdro_dtQuit).format('YYYY-MM-DD') } : {}),
        bdro_vlr: b.original.bdro_vlr,
        conta_id: b.original.bdro_vlr,
        bdro_usuarioCria: this.props.auth.user.pf_id,
        bdro_usuarioMod: this.props.auth.user.pf_id,
        bdro_favTab: b.original.bdro_favTab,
        bdro_favId: b.original.bdro_favId,
        orcItem_id: b.original.orcItem_id,
        bdro_desc: b.original.bdro_desc,
        bdro_orcPend: b.original.bdro_orcPend,
        bdro_pagador: b.original.bdro_pagador,
        bdro_codBarras: b.original.bdro_codBarras,
      };

      for (const key in data) {

        if (
          ((key !== "bdro_dtQuit" || key !== "bdro_orcPend") && (!data[key] && data[key] != 0) ||
          data[key] === 'Data inválida') &&
          key !== "bdro_codBarras"
        )
        {
          console.log(`${key} is falsy`);
          emptyValues.push({...b.original, campoComErro: `${key}`});
        }
        if (!b.original.keys_signals.documento_id_doc_cobranca && Number(b.original.keys_signals.bdro_dispDocCobranca) !== 1) {
          emptyValues.push({...b.original, campoComErro: `documento de cobranca`});
        }

        if (!b.original.keys_signals.documento_id_nota_fiscal && Number(b.original.keys_signals.bdro_dispNF) !== 1) {
          emptyValues.push({...b.original, campoComErro: `nota fiscal`});
        }

        if (emptyValues.length > 0) {
          this.setState({ emptyValues: emptyValues, bdroComErro: b.original });
          this.handleOpenErrorModal();
          breakOutsideFor = true;
          break;
        }
      }

      if (breakOutsideFor) {
        break;
      }

      //chamada para a kamino
      const kaminoBody = {
        acao: 'kamino_salvar_pgto',
        id: b.original.bdro_id,
      }

      const res = await powerappsApi.post('/', kaminoBody, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      });

      this.getOneBdroRecord(b.original.bdro_id);
    }

    notifySuccess('Envio para o banco concluído com sucesso!');
    this.setState({borderoSendingToKamino: null});
  }

  handleOpenPublishModal = (leafRows, rowId) => {
    this.setState({
      publishConfirmModalOpen: true,
      publishModalData: { leafRows, rowId },
    });
  }

  handleClosePublishModal = () => {
    this.setState({
      publishConfirmModalOpen: false,
      publishModalData: null,
      publishModalLoading: false,
    });
  }

  openDocsViewer = (record) => {
    this.setState({ docsViewerOpen: true, docsViewerRecord: record })
  }

  closeDocsViewer = () => {
    this.setState({ docsViewerOpen: false, docsViewerRecord: null })
  }

  getDocsViewerFields = (record) => {
    if (!record) return []
    const favorecido = record.bdro_favTab === 'pf'
      ? record.pf_nomeExibicao
      : record.bdro_favTab === 'pj'
        ? record.pj_razaosocial
        : null
    const conta = (this.state.accounts || []).find((a) => a.conta_id === record.conta_id)
    return [
      { label: 'ID', value: record.bdro_id },
      { label: 'Favorecido', value: favorecido },
      { label: 'Descrição', value: record.bdro_desc },
      {
        label: 'Valor',
        value: record.bdro_vlr != null
          ? currencyFormatter.format(Number(record.bdro_vlr))
          : null,
      },
      {
        label: 'Vencimento',
        value: record.bdro_dtVenc
          ? moment(record.bdro_dtVenc).format('DD/MM/YYYY')
          : null,
      },
      {
        label: 'Data Pagamento',
        value: record.bdro_dtQuit
          ? moment(record.bdro_dtQuit).format('DD/MM/YYYY')
          : null,
      },
      { label: 'Item orçamentário', value: record.label },
      { label: 'Banco de envio', value: conta?.conta_nome },
    ]
  }

  renderDocsViewer = () => {
    const { docsViewerOpen, docsViewerRecord } = this.state
    return (
      <ModalOikosDocsViewer
        open={docsViewerOpen}
        onClose={this.closeDocsViewer}
        tabRef="bdro"
        tabId={docsViewerRecord?.bdro_id}
        title={`Documentos · Borderô #${docsViewerRecord?.bdro_id || ''}`}
        recordFields={this.getDocsViewerFields(docsViewerRecord)}
        fileBaseUrl={FILE_BASE}
      />
    )
  }

  handleConfirmPublish = async () => {
    const { publishModalData } = this.state;
    if (!publishModalData) {
      return;
    }
    this.setState({ publishModalLoading: true });
    await this.enviarBorderosParaOBanco(publishModalData.leafRows, publishModalData.rowId);
    this.handleClosePublishModal();
  }

  // AQUI DEVEMOS FAZER A BUSCA DOS DOCUMENTOS QUANDO ESTAMOS NA TELA DO BORDERO DO PROJETO.
  isParcelaCartao = (row) => (
    Number(row?.meioPgto_id) === 6
    || Number(row?.contrFornEvento_meioPgto_id) === 6
    || Number(row?.contrForn_meioPgto_id) === 6
  )

  parcelasDoBordero = (lista) => {
    const rows = Array.isArray(lista) ? lista : []
    if (this.state.exibirParcelasCartao) return rows
    return rows.filter((row) => !this.isParcelaCartao(row))
  }

  getBdroRecords = async(inicioFim = null) => {

    this.setState({dataIsLoading: true });

    const {proj_orcRubrId} = this.props

    if (!proj_orcRubrId) {

      const resNaoPend = await powerappsApi.post('/',
        {
          acao: 'get_bdro',
          graph_id: this.props.auth.user.id,
          pend: 0,
          ...(inicioFim && {inicio: inicioFim.inicio, fim: inicioFim.fim}),
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'multipart/form-data',
          },
        }
      );

      console.log('resNaoPend', resNaoPend)

      const updatedObjectNaoPend = resNaoPend.data.map(obj => ({
        ...obj,
        bdro_codBarras: String(obj.bdro_codBarras),
        keys_signals: {
          kamino_id: obj.kamino_id,
          documento_id_doc_cobranca: obj.documento_id_doc_cobranca,
          documento_id_nota_fiscal: obj.documento_id_nota_fiscal,
          documento_id_comprovante: obj.documento_id_comprovante,
          bdro_dispNF: obj.bdro_dispNF,
          bdro_dispDocCobranca: obj.bdro_dispDocCobranca,
        },
        pend: false,
      }));

      console.log(updatedObjectNaoPend);

      const resPend =  await powerappsApi.post('/',
        {
          acao: 'get_bdro',
          graph_id: this.props.auth.user.id,
          pend: 1,
          ...(inicioFim && {inicio: inicioFim.inicio, fim: inicioFim.fim}),
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'multipart/form-data',
          },
        }
      );
      const updatedObjectPend = resPend.data.map(obj => ({
        ...obj,
        bdro_codBarras: String(obj.bdro_codBarras),
        keys_signals: {
          kamino_id: obj.kamino_id,
          documento_id_doc_cobranca: obj.documento_id_doc_cobranca,
          documento_id_nota_fiscal: obj.documento_id_nota_fiscal,
          documento_id_comprovante: obj.documento_id_comprovante,
          bdro_dispNF: obj.bdro_dispNF,
          bdro_dispDocCobranca: obj.bdro_dispDocCobranca,
        },
        pend: true,
      }));

      console.log(updatedObjectPend);

      this.setState({ dataNaoPend: updatedObjectNaoPend, dataPend: updatedObjectPend, dataIsLoading: false  });
    } else {

      const in_txt = `!IN!(SELECT orcItem_id FROM orcItem WHERE orcRubr_id IN (SELECT id_oikos FROM viewOrcRubr_taxonomia2 WHERE nivel3_id = ${proj_orcRubrId}))`;
      const resNaoPend = await oikosApi.get(
        `/?${qs.stringify({
          action: "get",
          table: "bdro",
          data: {
            orcItem_id: in_txt,
            bdro_orcPend: 0,
            bdro_ativo: 1,
          },
          fields: {
            "(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = bdro.bdro_favId AND bdro.bdro_favTab = 'pf')": "pf_nomeExibicao",

            "(SELECT pj_razaosocial FROM pj WHERE pj.pj_id = bdro.bdro_favId AND bdro.bdro_favTab = 'pj')": "pj_razaosocial",

            "(SELECT CONCAT((SELECT rubrica FROM viewOrcRubr_taxonomia2 WHERE viewOrcRubr_taxonomia2.id_oikos = (SELECT orcRubr_id FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id AND orcItem_ativo = 1)),'::',(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id)))": "label",

            "(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id)": "orcItem_desc",

            "(SELECT categ_id FROM categ WHERE categ.categ_id = (SELECT categ_id FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id))": "categ_id",

            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 29 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_doc_cobranca",

            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 27 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_nota_fiscal",
            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 28 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_comprovante",

            "(SELECT cfe.contrFornEvento_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1)": "contrFornEvento_id",

            "(SELECT cfe.contrForn_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1)": "contrForn_id",

            "(SELECT cf.contrForn_dtVigFim FROM contrForn cf WHERE cf.contrForn_id = (SELECT cfe.contrForn_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1) LIMIT 1)": "contrForn_dtVigFim",

            "(SELECT cf.contrForn_vlrGlobal FROM contrForn cf WHERE cf.contrForn_id = (SELECT cfe.contrForn_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1) LIMIT 1)": "contrForn_vlrGlobal",

            "(SELECT SUM(cfe_sum.contrFornEvento_vlr) FROM contrFornEvento cfe_sum WHERE cfe_sum.contrForn_id = (SELECT cfe.contrForn_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1))": "contrForn_soma_parcelas",

            "(SELECT CASE WHEN ROUND(COALESCE((SELECT SUM(cfe_sum.contrFornEvento_vlr) FROM contrFornEvento cfe_sum WHERE cfe_sum.contrForn_id = cf.contrForn_id), 0), 2) = ROUND(COALESCE(cf.contrForn_vlrGlobal, 0), 2) THEN 1 ELSE 0 END FROM contrForn cf WHERE cf.contrForn_id = (SELECT cfe.contrForn_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1) LIMIT 1)": "contrForn_parcelas_batem_vlrGlobal",

            "(SELECT pf_orcItem.pf_emailProf FROM pf pf_orcItem WHERE pf_orcItem.pf_id = (SELECT oi.pf_id FROM orcItem oi WHERE oi.orcItem_id = bdro.orcItem_id AND oi.orcItem_ativo = 1 LIMIT 1) LIMIT 1)": "orcItem_pf_emailProf",

            "(SELECT pf_orcItem.pf_nomeExibicao FROM pf pf_orcItem WHERE pf_orcItem.pf_id = (SELECT oi.pf_id FROM orcItem oi WHERE oi.orcItem_id = bdro.orcItem_id AND oi.orcItem_ativo = 1 LIMIT 1) LIMIT 1)": "orcItem_pf_nomeExibicao",

            "(SELECT proj_nome FROM proj WHERE proj.orcRubr_id = (SELECT orcRubr_mae FROM orcRubr WHERE orcRubr.orcRubr_id = (SELECT orcRubr_id FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id LIMIT 1) LIMIT 1) LIMIT 1)": "proj_nome",
          },
        })}`
      );

      console.log('resNaoPend', resNaoPend)

      const updatedObjectNaoPend = resNaoPend.data.map(obj => ({
        ...obj,
        bdro_codBarras: String(obj.bdro_codBarras),
        keys_signals: {
          kamino_id: obj.kamino_id,
          documento_id_doc_cobranca: obj.documento_id_doc_cobranca,
          documento_id_nota_fiscal: obj.documento_id_nota_fiscal,
          documento_id_comprovante: obj.documento_id_comprovante,
          bdro_dispNF: obj.bdro_dispNF,
          bdro_dispDocCobranca: obj.bdro_dispDocCobranca,
        },
        pend: false,
      }));


      console.log(resNaoPend.data)

      const resPend = await oikosApi.get(
        `/?${qs.stringify({
          action: "get",
          table: "bdro",
          data: {
            orcItem_id: in_txt,
            bdro_orcPend: 1,
            bdro_ativo: 1,
          },
          fields: {
            "(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = bdro.bdro_favId AND bdro.bdro_favTab = 'pf')": "pf_nomeExibicao",

            "(SELECT pj_razaosocial FROM pj WHERE pj.pj_id = bdro.bdro_favId AND bdro.bdro_favTab = 'pj')": "pj_razaosocial",

            "(SELECT CONCAT((SELECT rubrica FROM viewOrcRubr_taxonomia2 WHERE viewOrcRubr_taxonomia2.id_oikos = (SELECT orcRubr_id FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id AND orcItem_ativo = 1)),'::',(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id)))": "label",

            "(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id)": "orcItem_desc",

            "(SELECT categ_id FROM categ WHERE categ.categ_id = (SELECT categ_id FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id))": "categ_id",

            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 29 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_doc_cobranca",

            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 27 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_nota_fiscal",
            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 28 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_comprovante",

            "(SELECT cfe.contrFornEvento_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1)": "contrFornEvento_id",

            "(SELECT cfe.contrForn_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1)": "contrForn_id",

            "(SELECT cf.contrForn_dtVigFim FROM contrForn cf WHERE cf.contrForn_id = (SELECT cfe.contrForn_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1) LIMIT 1)": "contrForn_dtVigFim",

            "(SELECT cf.contrForn_vlrGlobal FROM contrForn cf WHERE cf.contrForn_id = (SELECT cfe.contrForn_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1) LIMIT 1)": "contrForn_vlrGlobal",

            "(SELECT SUM(cfe_sum.contrFornEvento_vlr) FROM contrFornEvento cfe_sum WHERE cfe_sum.contrForn_id = (SELECT cfe.contrForn_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1))": "contrForn_soma_parcelas",

            "(SELECT CASE WHEN ROUND(COALESCE((SELECT SUM(cfe_sum.contrFornEvento_vlr) FROM contrFornEvento cfe_sum WHERE cfe_sum.contrForn_id = cf.contrForn_id), 0), 2) = ROUND(COALESCE(cf.contrForn_vlrGlobal, 0), 2) THEN 1 ELSE 0 END FROM contrForn cf WHERE cf.contrForn_id = (SELECT cfe.contrForn_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1) LIMIT 1)": "contrForn_parcelas_batem_vlrGlobal",

            "(SELECT pf_orcItem.pf_emailProf FROM pf pf_orcItem WHERE pf_orcItem.pf_id = (SELECT oi.pf_id FROM orcItem oi WHERE oi.orcItem_id = bdro.orcItem_id AND oi.orcItem_ativo = 1 LIMIT 1) LIMIT 1)": "orcItem_pf_emailProf",

            "(SELECT pf_orcItem.pf_nomeExibicao FROM pf pf_orcItem WHERE pf_orcItem.pf_id = (SELECT oi.pf_id FROM orcItem oi WHERE oi.orcItem_id = bdro.orcItem_id AND oi.orcItem_ativo = 1 LIMIT 1) LIMIT 1)": "orcItem_pf_nomeExibicao",

            "(SELECT proj_nome FROM proj WHERE proj.orcRubr_id = (SELECT orcRubr_mae FROM orcRubr WHERE orcRubr.orcRubr_id = (SELECT orcRubr_id FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id LIMIT 1) LIMIT 1) LIMIT 1)": "proj_nome",
          },
        })}`
      );

      const updatedObjectPend = resPend.data.map(obj => ({
        ...obj,
        bdro_codBarras: String(obj.bdro_codBarras),
        keys_signals: {
          kamino_id: obj.kamino_id,
          documento_id_doc_cobranca: obj.documento_id_doc_cobranca,
          documento_id_nota_fiscal: obj.documento_id_nota_fiscal,
          documento_id_comprovante: obj.documento_id_comprovante,
          bdro_dispNF: obj.bdro_dispNF,
          bdro_dispDocCobranca: obj.bdro_dispDocCobranca,
        },
        pend: true,
      }));

      this.setState({ dataNaoPend: updatedObjectNaoPend, dataPend: updatedObjectPend, dataIsLoading: false });

    }

  }

  // AQUI ATUALIZAREMOS O REGISTRO DE UM BORDERO.
  getOneBdroRecord = async(bdro_id) => {

    const {proj_orcRubrId} = this.props

    if (!proj_orcRubrId) {

      const resNaoPend = await oikosApi.get(
        `/?${qs.stringify({
          action: "get",
          table: "bdro",
          data: {
            bdro_orcPend: 0,
            bdro_ativo: 1,
            bdro_id: bdro_id,
          },
          fields: {
            "(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = bdro.bdro_favId AND bdro.bdro_favTab = 'pf')": "pf_nomeExibicao",

            "(SELECT pj_razaosocial FROM pj WHERE pj.pj_id = bdro.bdro_favId AND bdro.bdro_favTab = 'pj')": "pj_razaosocial",

            "(SELECT CONCAT((SELECT rubrica FROM viewOrcRubr_taxonomia2 WHERE viewOrcRubr_taxonomia2.id_oikos = (SELECT orcRubr_id FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id AND orcItem_ativo = 1)),'::',(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id)))": "label",

            "(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id)": "orcItem_desc",

            "(SELECT categ_id FROM categ WHERE categ.categ_id = (SELECT categ_id FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id))": "categ_id",

            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 29 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_doc_cobranca",

            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 27 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_nota_fiscal",
            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 28 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_comprovante",

            "(SELECT cfe.contrFornEvento_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1)": "contrFornEvento_id",

            "(SELECT cfe.contrForn_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1)": "contrForn_id",

            "(SELECT cf.contrForn_dtVigFim FROM contrForn cf WHERE cf.contrForn_id = (SELECT cfe.contrForn_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1) LIMIT 1)": "contrForn_dtVigFim",

            "(SELECT cf.contrForn_vlrGlobal FROM contrForn cf WHERE cf.contrForn_id = (SELECT cfe.contrForn_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1) LIMIT 1)": "contrForn_vlrGlobal",

            "(SELECT SUM(cfe_sum.contrFornEvento_vlr) FROM contrFornEvento cfe_sum WHERE cfe_sum.contrForn_id = (SELECT cfe.contrForn_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1))": "contrForn_soma_parcelas",

            "(SELECT CASE WHEN ROUND(COALESCE((SELECT SUM(cfe_sum.contrFornEvento_vlr) FROM contrFornEvento cfe_sum WHERE cfe_sum.contrForn_id = cf.contrForn_id), 0), 2) = ROUND(COALESCE(cf.contrForn_vlrGlobal, 0), 2) THEN 1 ELSE 0 END FROM contrForn cf WHERE cf.contrForn_id = (SELECT cfe.contrForn_id FROM contrFornEvento cfe WHERE cfe.contrFornEvento_id = bdro.bdro_tabId AND bdro.bdro_tabRef = 'contrFornEvento' AND bdro.bdro_tabId IS NOT NULL LIMIT 1) LIMIT 1)": "contrForn_parcelas_batem_vlrGlobal",

            "(SELECT pf_orcItem.pf_emailProf FROM pf pf_orcItem WHERE pf_orcItem.pf_id = (SELECT oi.pf_id FROM orcItem oi WHERE oi.orcItem_id = bdro.orcItem_id AND oi.orcItem_ativo = 1 LIMIT 1) LIMIT 1)": "orcItem_pf_emailProf",

            "(SELECT pf_orcItem.pf_nomeExibicao FROM pf pf_orcItem WHERE pf_orcItem.pf_id = (SELECT oi.pf_id FROM orcItem oi WHERE oi.orcItem_id = bdro.orcItem_id AND oi.orcItem_ativo = 1 LIMIT 1) LIMIT 1)": "orcItem_pf_nomeExibicao",
          }
        })}`
      );

      console.log('resNaoPend', resNaoPend)

      const updatedObjectNaoPend = resNaoPend.data.map(obj => ({
        ...obj,
        bdro_codBarras: String(obj.bdro_codBarras),
        keys_signals: {
          kamino_id: obj.kamino_id,
          documento_id_doc_cobranca: obj.documento_id_doc_cobranca,
          documento_id_nota_fiscal: obj.documento_id_nota_fiscal,
          documento_id_comprovante: obj.documento_id_comprovante,
          bdro_dispNF: obj.bdro_dispNF,
          bdro_dispDocCobranca: obj.bdro_dispDocCobranca,
        }
      }));


      console.log('updatedObjectNaoPend', updatedObjectNaoPend);

      const resPend = await oikosApi.get(
        `/?${qs.stringify({
          action: "get",
          table: "bdro",
          data: {
            bdro_orcPend: 1,
            bdro_ativo: 1,
            bdro_id: bdro_id,
          },
          fields: {
            "(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = bdro.bdro_favId AND bdro.bdro_favTab = 'pf')": "pf_nomeExibicao",
            "(SELECT pj_razaosocial FROM pj WHERE pj.pj_id = bdro.bdro_favId AND bdro.bdro_favTab = 'pj')": "pj_razaosocial",
            "(SELECT CONCAT((SELECT rubrica FROM viewOrcRubr_taxonomia2 WHERE viewOrcRubr_taxonomia2.id_oikos = (SELECT orcRubr_id FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id AND orcItem_ativo = 1)),'::',(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id)))": 'label',
            "(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id)": "orcItem_desc",
            "(SELECT categ_id FROM categ WHERE categ.categ_id = (SELECT categ_id FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id))": "categ_id",
            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 29 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_doc_cobranca",
            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 27 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_nota_fiscal",
            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 28 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_comprovante",
          },
        })}`
      );

      const updatedObjectPend = resPend.data.map(obj => ({
        ...obj,
        bdro_codBarras: String(obj.bdro_codBarras),
        keys_signals: {
          kamino_id: obj.kamino_id,
          documento_id_doc_cobranca: obj.documento_id_doc_cobranca,
          documento_id_nota_fiscal: obj.documento_id_nota_fiscal,
          documento_id_comprovante: obj.documento_id_comprovante,
          bdro_dispNF: obj.bdro_dispNF,
          bdro_dispDocCobranca: obj.bdro_dispDocCobranca,
        }
      }));

      console.log('updatedObjectPend', updatedObjectPend);

      this.setState(prevState => (
        {
          dataNaoPend: prevState.dataNaoPend.map(b => {
            if(b.bdro_id === bdro_id && updatedObjectNaoPend.length > 0) {
              return updatedObjectNaoPend[0];
            } else {
              return b;
            }
          }),
          dataPend: prevState.dataPend.map(b => {
            if(b.bdro_id === bdro_id && updatedObjectPend.length > 0) {
              return updatedObjectPend[0];
            } else {
              return b;
            }
          }),
          dataIsLoading: false
        }
      ));
    } else {

      const in_txt = `!IN!(SELECT orcItem_id FROM orcItem WHERE orcRubr_id IN (SELECT id_oikos FROM viewOrcRubr_taxonomia2 WHERE nivel3_id = ${proj_orcRubrId}))`;
      const resNaoPend = await oikosApi.get(
        `/?${qs.stringify({
          action: "get",
          table: "bdro",
          data: {
            orcItem_id: in_txt,
            bdro_orcPend: 0,
            bdro_ativo: 1,
            bdro_id: bdro_id,
          },
          fields: {
            "(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = bdro.bdro_favId AND bdro.bdro_favTab = 'pf')": "pf_nomeExibicao",
            "(SELECT pj_razaosocial FROM pj WHERE pj.pj_id = bdro.bdro_favId AND bdro.bdro_favTab = 'pj')": "pj_razaosocial",
            "(SELECT CONCAT((SELECT rubrica FROM viewOrcRubr_taxonomia2 WHERE viewOrcRubr_taxonomia2.id_oikos = (SELECT orcRubr_id FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id AND orcItem_ativo = 1)),'::',(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id)))": 'label',
            "(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id)": "orcItem_desc",
            "(SELECT categ_id FROM categ WHERE categ.categ_id = (SELECT categ_id FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id))": "categ_id",
            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 29 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_doc_cobranca",
            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 27 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_nota_fiscal",
            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 28 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_comprovante",         },
        })}`
      );

      console.log('resNaoPend', resNaoPend)

      const updatedObjectNaoPend = resNaoPend.data.map(obj => ({
        ...obj,
        bdro_codBarras: String(obj.bdro_codBarras),
        keys_signals: {
          kamino_id: obj.kamino_id,
          documento_id_doc_cobranca: obj.documento_id_doc_cobranca,
          documento_id_nota_fiscal: obj.documento_id_nota_fiscal,
          documento_id_comprovante: obj.documento_id_comprovante,
          bdro_dispNF: obj.bdro_dispNF,
          bdro_dispDocCobranca: obj.bdro_dispDocCobranca,
        }
      }));

      console.log('updatedObjectNaoPend', updatedObjectNaoPend);

      console.log(resNaoPend.data)

      const resPend = await oikosApi.get(
        `/?${qs.stringify({
          action: "get",
          table: "bdro",
          data: {
            orcItem_id: in_txt,
            bdro_orcPend: 1,
            bdro_ativo: 1,
            bdro_id: bdro_id,
          },
          fields: {
            "(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = bdro.bdro_favId AND bdro.bdro_favTab = 'pf')": "pf_nomeExibicao",
            "(SELECT pj_razaosocial FROM pj WHERE pj.pj_id = bdro.bdro_favId AND bdro.bdro_favTab = 'pj')": "pj_razaosocial",
            "(SELECT CONCAT((SELECT rubrica FROM viewOrcRubr_taxonomia2 WHERE viewOrcRubr_taxonomia2.id_oikos = (SELECT orcRubr_id FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id AND orcItem_ativo = 1)),'::',(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id)))": 'label',
            "(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id)": "orcItem_desc",
            "(SELECT categ_id FROM categ WHERE categ.categ_id = (SELECT categ_id FROM orcItem WHERE orcItem.orcItem_id = bdro.orcItem_id))": "categ_id",
            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 29 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_doc_cobranca",
            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 27 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_nota_fiscal",
            "(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 28 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = bdro.bdro_id) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)": "documento_id_comprovante",          },
        })}`
      );

      const updatedObjectPend = resPend.data.map(obj => ({
        ...obj,
        bdro_codBarras: String(obj.bdro_codBarras),
        keys_signals: {
          kamino_id: obj.kamino_id,
          documento_id_doc_cobranca: obj.documento_id_doc_cobranca,
          documento_id_nota_fiscal: obj.documento_id_nota_fiscal,
          documento_id_comprovante: obj.documento_id_comprovante,
          bdro_dispNF: obj.bdro_dispNF,
          bdro_dispDocCobranca: obj.bdro_dispDocCobranca,
        }
      }));

      console.log('updatedObjectPend', updatedObjectPend);

      this.setState(prevState => (
        {
          dataNaoPend: prevState.dataNaoPend.map(b => {
            if(b.bdro_id === bdro_id && updatedObjectNaoPend.length > 0) {
              return updatedObjectNaoPend[0];
            } else {
              return b;
            }
          }),
          dataPend: prevState.dataPend.map(b => {
            if(b.bdro_id === bdro_id && updatedObjectPend.length > 0) {
              return updatedObjectPend[0];
            } else {
              return b;
            }
          }),
          dataIsLoading: false
        }
      ));
    }

  }

  formatVencimentoYmd = (value) => {
    if (!value && value !== 0) return null
    const m = moment(value)
    return m.isValid() ? m.format('YYYY-MM-DD') : null
  }

  getRowDropDate = (row) => {
    if (typeof row?.getIsGrouped === 'function' && row.getIsGrouped()) {
      const colId = row.groupingColumnId
      if (colId && colId !== 'bdro_dtVenc') return null
      const grouped = row.groupingValue ?? (typeof row.getValue === 'function' ? row.getValue('bdro_dtVenc') : null)
      return this.formatVencimentoYmd(grouped)
    }
    return this.formatVencimentoYmd(row?.original?.bdro_dtVenc)
  }

  onBdroDragStart = (event, record) => {
    if (!record?.bdro_id) return
    event.stopPropagation()
    const payload = String(record.bdro_id)
    event.dataTransfer.setData('application/x-oikos-bdro', payload)
    event.dataTransfer.setData('text/plain', payload)
    event.dataTransfer.effectAllowed = 'move'
    this.setState({ bdroDraggingId: record.bdro_id })
  }

  onBdroDragEnd = () => {
    this.setState({ bdroDraggingId: null, bdroDropRowId: null })
  }

  onBdroDragOver = (event, row) => {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'move'
    if (this.state.bdroDropRowId !== row.id) {
      this.setState({ bdroDropRowId: row.id })
    }
  }

  onBdroDragLeave = (event, row) => {
    if (this.state.bdroDropRowId === row.id) {
      this.setState({ bdroDropRowId: null })
    }
  }

  onBdroDrop = async (event, row) => {
    event.preventDefault()
    event.stopPropagation()
    const rawId = event.dataTransfer.getData('application/x-oikos-bdro')
      || event.dataTransfer.getData('text/plain')
    const bdroId = Number(rawId)
    const newDate = this.getRowDropDate(row)
    this.setState({ bdroDropRowId: null, bdroDraggingId: null })
    if (!bdroId || !newDate) return

    const record = [...(this.state.dataNaoPend || []), ...(this.state.dataPend || [])]
      .find((b) => Number(b.bdro_id) === bdroId)
    if (!record) return
    if (record.keys_signals?.kamino_id || record.kamino_id) {
      notifyError('Este compromisso já foi enviado ao banco e não pode ter o vencimento alterado por arrastar.')
      return
    }
    const oldDate = this.formatVencimentoYmd(record.bdro_dtVenc)
    if (oldDate === newDate) return
    if (this.state.bdroMoving) return

    const user = this.props.auth?.user
    const patchList = (list) => (list || []).map((b) => (
      Number(b.bdro_id) === bdroId ? { ...b, bdro_dtVenc: newDate } : b
    ))

    this.setState((prev) => ({
      bdroMoving: true,
      dataNaoPend: patchList(prev.dataNaoPend),
      dataPend: patchList(prev.dataPend),
    }))

    try {
      await oikosApi.post('/', {
        action: 'update',
        table: 'bdro',
        data: {
          bdro_id: bdroId,
          bdro_dtVenc: newDate,
          bdro_usuarioMod: user?.pf_id,
        },
      })
      notifySuccess(`Vencimento alterado para ${moment(newDate).format('DD/MM/YYYY')}.`)
      if (this.getOneBdroRecord) {
        await this.getOneBdroRecord(bdroId)
      }
    } catch (err) {
      console.error(err)
      notifyError('Não foi possível alterar a data de vencimento.')
      await this.preloading()
    } finally {
      this.setState({ bdroMoving: false })
    }
  }

  getBdroTableDndProps = (canEditRow) => ({
    muiTableBodyRowProps: ({ row }) => {
      const isGroup = typeof row.getIsGrouped === 'function' && row.getIsGrouped()
      const record = row.original
      const alreadySent = Boolean(record?.keys_signals?.kamino_id || record?.kamino_id)
      const canDrag = Boolean(
        canEditRow
        && !isGroup
        && record?.bdro_id
        && !alreadySent
        && !this.state.bdroMoving
      )
      const dropDate = this.getRowDropDate(row)
      const canDrop = Boolean(canEditRow && dropDate && !this.state.bdroMoving)
      const isDropTarget = this.state.bdroDropRowId === row.id
      return {
        hover: true,
        draggable: canDrag,
        title: canDrag
          ? 'Arraste para outro dia para alterar o vencimento'
          : (isGroup && canDrop ? 'Solte aqui para alterar o vencimento para este dia' : undefined),
        onDragStart: canDrag ? (e) => this.onBdroDragStart(e, record) : undefined,
        onDragEnd: this.onBdroDragEnd,
        onDragOver: canDrop ? (e) => this.onBdroDragOver(e, row) : undefined,
        onDragLeave: canDrop ? (e) => this.onBdroDragLeave(e, row) : undefined,
        onDrop: canDrop ? (e) => this.onBdroDrop(e, row) : undefined,
        sx: {
          cursor: canDrag ? 'grab' : undefined,
          opacity: this.state.bdroDraggingId && Number(this.state.bdroDraggingId) === Number(record?.bdro_id) ? 0.45 : 1,
          outline: isDropTarget ? '2px dashed #0f766e' : undefined,
          outlineOffset: '-2px',
          backgroundColor: isDropTarget ? 'rgba(15, 118, 110, 0.08)' : undefined,
        },
      }
    },
  })

  convertValueToText = (value) => {
    switch (value.campoComErro) {
      case 'bdro_dtVenc':
        return 'Data de Vencimento';
      case 'bdro_dtQuit':
        return 'Data de Quitação';
      case 'conta_id':
        return 'Conta';
      case 'orcItem_id':
          return 'Item orçamentário';
      case 'bdro_favId':
        return 'Favorecido';
      case 'bdro_desc':
        return 'Descrição';
      case 'categ_id':
        return 'Categoria';
      case 'documento de cobranca':
        return 'Documento de cobrança';
      case 'nota fiscal':
        return 'Nota Fiscal';
      case 'bdro_pagador':
        return 'Pagador';
      case 'bdro_codBarras':
        return 'Código de barras';
    }
  }

  render() {

    const { dataIsLoading, dataNaoPend, dataPend, exibirParcelasCartao, oikos_usuario, oikos_senha, pqGridViewIsOpen, addProductData, addProductModalIsOpen, productDetails  } = this.state
    const dataNaoPendVisivel = this.parcelasDoBordero(dataNaoPend)
    const dataPendVisivel = this.parcelasDoBordero(dataPend)
    const ocultasCartao = (Array.isArray(dataNaoPend) ? dataNaoPend : []).filter(this.isParcelaCartao).length
      + (Array.isArray(dataPend) ? dataPend : []).filter(this.isParcelaCartao).length
    const toggleCartao = (
      <label className="ml-3 mb-0 align-middle" style={{ fontWeight: 'normal', cursor: 'pointer' }}>
        <input
          type="checkbox"
          className="mr-1"
          checked={!!exibirParcelasCartao}
          onChange={(event) => this.setState({ exibirParcelasCartao: event.target.checked })}
        />
        Exibir parcelas de cartão
        {!exibirParcelasCartao && ocultasCartao > 0 ? ` (${ocultasCartao} ocultas)` : ''}
      </label>
    )
    const { project, getProjectIsLoading,
      getProjectProductsIsLoading, projectProducts,
      projectTeam, getProjectTeamIsLoading,
      getTeamIsLoading, aval, getAvalIsLoading, aprov, getAprovIsLoading, } = this.props.technicalDep
    const { user } = this.props.auth;
    //const { isManager } = this.props.auth.user

    const canEditRow = [1, 2, 3, 31, 141].includes(user.pf_id)
    const canUploadDocs = user.perm_id === 1
    const bdroDndTableProps = this.getBdroTableDndProps(canEditRow)

    const makeDocUpload = (row, kind) => {
      const isNF = kind === 'nf'
      return (
        <AddFilesNoForm
          multiple={false}
          accept={['.pdf']}
          pocket={true}
          compact={true}
          compactLabel={
            <i
              className={isNF ? 'ri-bill-line' : 'ri-barcode-box-line'}
              style={statusIconStyle('missing')}
              title={isNF ? 'Nota fiscal: faltando — clique para anexar' : 'Documento de cobrança: faltando — clique para anexar'}
            />
          }
          documentLabel={isNF ? 'Nota Fiscal' : 'Documento de cobrança'}
          files={isNF ? this.state.notaFiscalFile : this.state.documentoCobrancaFile}
          onFilesChange={isNF ? this.onFilesChangeNF : this.onFilesChangeDocCobranca}
          tpDocumentoId={isNF ? 27 : 29}
          registro={row}
          tabRef={'bdro'}
          updateBdroRecord={this.getOneBdroRecord}
        />
      )
    }

    const columns = [
      {
        id: 'acoes',
        header: '',
        accessorFn: (row) => {
          if (user.pf_id !== 3) return null
          return (
            <div className="d-flex align-items-center justify-content-start">
              <IconButton size="small" style={{ padding: 2 }} onClick={(e) => e.stopPropagation()}>
                <ModalDeleteBordero data={row} preloading={this.preloading}/>
              </IconButton>
            </div>
          )
        },
        AggregatedCell: ({ cell }) => {
          if (user.perm_id === 1 && this.state.borderoSendingToKamino !== cell.row.id && cell.row.leafRows.some(b => !b.original.keys_signals.kamino_id)) {
            return (
              <Button onClick={() => this.handleOpenPublishModal(cell.row.leafRows, cell.row.id)}>
                <Publish/>
              </Button>
            )
          } else if (user.perm_id === 1 && this.state.borderoSendingToKamino === cell.row.id) {
            return <Spinner/>;
          }
          return null;
        },
        size: 36,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        id: 'docs',
        header: 'NF',
        Cell: ({ row }) => (
          <BorderoDocsInline
            keys_signals={row.original.keys_signals}
            canUpload={canUploadDocs}
            notaFiscalUpload={makeDocUpload(row.original, 'nf')}
            docCobrancaUpload={makeDocUpload(row.original, 'cob')}
            onOpenViewer={() => this.openDocsViewer(row.original)}
          />
        ),
        size: 156,
        enableSorting: false,
        enableColumnFilter: false,
        enableHiding: false,
      },
      {
        accessorKey: 'bdro_favId',
        header: 'Favorecido',
        accessorFn: (row) => {
          if (row.bdro_favTab === 'pf') return row.pf_nomeExibicao
          if (row.bdro_favTab === 'pj') return row.pj_razaosocial
          return null
        },
        size: 180,
        filterVariant: 'text',
        filterFn: 'includesString',
      },
      {
        accessorKey: 'bdro_desc',
        header: 'Descrição',
        accessorFn: (row) => row.bdro_desc || null,
        Cell: ({ row }) => {
          const desc = row.original.bdro_desc || '—'
          if (!canEditRow) {
            return <span title={desc}>{desc}</span>
          }
          return (
            <ModalEdicaoContaAPagar
              proj_id={this.props.proj_id}
              data={row.original}
              user={user}
              preloading={this.preloading}
              getOneBdroRecord={this.getOneBdroRecord}
              trigger={
                <span
                  title="Clique para editar"
                  style={{
                    cursor: 'pointer',
                    color: '#0f766e',
                    textDecoration: 'underline',
                    textUnderlineOffset: 2,
                  }}
                >
                  {desc}
                </span>
              }
            />
          )
        },
        size: 220,
        filterVariant: 'text',
        filterFn: 'includesString',
      },
      {
        accessorKey: 'bdro_vlr',
        header: 'Valor',
        accessorFn: (row) => (row.bdro_vlr ? Number(row.bdro_vlr) : null),
        aggregationFn: 'sum',
        AggregatedCell: ({ cell }) => (
          <Box sx={{ fontWeight: 'bold' }}>
            {cell.getValue()?.toLocaleString?.('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Box>
        ),
        size: 100,
        filterVariant: 'range',
        sortingFn: 'alphanumeric',
        Cell: ({ cell }) => (
          <>
            {cell.getValue()?.toLocaleString?.('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </>
        ),
      },
      {
        accessorKey: 'bdro_dtQuit',
        header: 'Data Pagamento',
        accessorFn: (row) => (row.bdro_dtQuit ? moment(row.bdro_dtQuit, 'YYYY-MM-DD').toDate() : null),
        muiTableBodyCellProps: { align: 'left' },
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => (
          row.original.bdro_dtQuit ? moment(cell.getValue()).format('DD/MM/YYYY') : '—'
        ),
        filterVariant: 'range',
        filterFn: 'dateRangeFilterFn',
        size: 120,
        enableHiding: false,
      },
      {
        accessorKey: 'label',
        header: 'Item orçamentário',
        accessorFn: (row) => row.label || null,
        size: 160,
        filterVariant: 'text',
        filterFn: 'includesString',
      },
      {
        accessorKey: 'conta_id',
        header: 'Banco de envio',
        accessorFn: (row) => row.conta_id || null,
        size: 140,
        sortingFn: 'alphanumeric',
        Cell: ({ row }) => {
          if (!row.original.conta_id || !this.state.accounts) return null
          const conta = this.state.accounts.find(obj => obj.conta_id === row.original.conta_id)
          return conta?.conta_nome || null
        },
      },
      {
        accessorKey: 'bdro_dtVenc',
        header: 'Vencimento',
        accessorFn: (row) => (row.bdro_dtVenc ? moment(row.bdro_dtVenc, 'YYYY-MM-DD').toDate() : null),
        muiTableBodyCellProps: { align: 'left' },
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => (
          row.original.bdro_dtVenc ? moment(cell.getValue()).format('DD/MM/YYYY') : null
        ),
        filterVariant: 'range',
        filterFn: 'dateRangeFilterFn',
        size: 90,
      },
    ]



    if (dataIsLoading) {
      return (
        <Card className='centered'>
          <CardBody>
            <span>Carregando...</span>
          </CardBody>
        </Card>
      )
    }

    if (dataNaoPend && dataPend && this.state.accounts) {
      return (
        <>
          {this.renderDocsViewer()}
          {
            (!this.props.proj_orcRubrId && (user.perm_id === 1 || user.perm_id === 2 || user.perm_id === 3)) ?
            <div className='p-5' style={this.props.proj_id ? {} : {marginTop: "100px"}}>
              <Tabs>
                <TabList>
                  <Tab>Solicitações ({dataNaoPendVisivel.length})</Tab>
                  <Tab>Pendentes ({dataPendVisivel.length})</Tab>
                  <Button onClick={() => this.getBdroRecords()}>Carregar todos borderôs</Button>
                  {toggleCartao}
                </TabList>
                <TabPanel>
                  <MaterialReactTable
                    columns={columns}
                    data={dataNaoPendVisivel}
                    initialState={{
                      density: 'compact',
                      grouping: ['bdro_dtVenc'],
                      expanded: {}, // dias começam colapsados
                      pagination: { pageIndex: 0, pageSize: 50 },
                      sorting: [{ id: 'bdro_dtVenc', desc: true }], //sort by state by default
                    }}
                    filterFns={{
                      dateRangeFilterFn: (row, id, filterValue) => {

                        if (!filterValue || !filterValue[0] || !filterValue[1]) {
                          return true; // Return true to show all rows if the filter is cleared
                        }

                        return ((row.getValue(id) >= (new Date(filterValue[0])).getTime()) && (row.getValue(id) <= (new Date(filterValue[1])).getTime()))
                      },
                    }}
                    enableFacetedValues

                    enableGrouping
                    {...bdroDndTableProps}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    enablePagination={(dataNaoPendVisivel.length > 50)}
                    muiTopToolbarProps={{sx: {
                      '.MuiButton-root .MuiSvgIcon-root': {width: "20px"},
                      '.MuiBox-root': {marginTop: "10px", height: "fit-content", display: "flex", alignItems: "center"},
                      '.MuiSvgIcon-root': {width: '12px'},
                      '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'},
                      '.MuiTablePagination-root .MuiToolbar-root': {minHeight: "30px !important", height: "30px !important"},
                      '.MuiTablePagination-root': {minHeight: "30px !important", height: "30px !important", marginTop: "2.3rem"},
                    }}}
                    muiTableBodyCellProps={{sx: denseBodyCellSx}}
                    muiTableContainerProps={{ sx: { maxWidth: '100%', overflowX: 'auto' } }}
                    /*
                    */
                    tableInstanceRef={this.tableRef}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Contas por página</span>,
                      rowsPerPageOptions: [50, 100],
                    }}
                    positionPagination='top'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableRowExpansion={true}
                    enableDensityToggle={false}
                    enableColumnFilters={true}
                    muiTableHeadCellProps={{
                      sx: denseHeadCellSx,
                    }}
                    renderTopToolbarCustomActions={() => {
                      if ([1, 2, 3, 141, this.props.project?.pf_id_coordenador].includes(user.pf_id)) {
                          return (
                          <Box marginLeft="auto">
                            <IconButton>
                              <ModalAddContaAPagar
                                {...this.props}
                                proj_id={this.props.proj_id}
                                user={user}
                                preloading={this.preloading}
                                getOneBdroRecord={this.getOneBdroRecord}
                              />
                            </IconButton>
                          </Box>
                        )
                      } else {
                        return null;
                      }
                    }}
                    />
                </TabPanel>
                <TabPanel>
                  <MaterialReactTable
                    columns={columns}
                    data={dataPendVisivel}
                    initialState={{
                      density: 'compact',
                      grouping: ['bdro_dtVenc'],
                      expanded: {}, // dias começam colapsados
                      pagination: { pageIndex: 0, pageSize: 50 },
                      sorting: [{ id: 'bdro_dtVenc', desc: false }], //sort by state by default
                    }}
                    filterFns={{
                      dateRangeFilterFn: (row, id, filterValue) => {

                        if (!filterValue || !filterValue[0] || !filterValue[1]) {
                          return true; // Return true to show all rows if the filter is cleared
                        }

                        return ((row.getValue(id) >= (new Date(filterValue[0])).getTime()) && (row.getValue(id) <= (new Date(filterValue[1])).getTime()))
                      },
                    }}
                    enableFacetedValues
                    enableGrouping
                    {...bdroDndTableProps}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    enablePagination={(dataPendVisivel.length > 50)}
                    muiTopToolbarProps={{sx: {
                      '.MuiButton-root .MuiSvgIcon-root': {width: "20px"},
                      '.MuiBox-root': {marginTop: "10px", height: "fit-content", display: "flex", alignItems: "center"},
                      '.MuiSvgIcon-root': {marginBottom: "20px", width: '12px'},
                      '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'},
                      '.MuiTablePagination-root .MuiToolbar-root': {minHeight: "30px !important", height: "30px !important"},
                      '.MuiTablePagination-root': {minHeight: "30px !important", height: "30px !important", marginTop: "2.3rem"},
                    }}}

                    muiTableBodyCellProps={{sx: denseBodyCellSx}}
                    muiTableContainerProps={{ sx: { maxWidth: '100%', overflowX: 'auto' } }}
                    /*
                    */
                    tableInstanceRef={this.tableRef}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Contas por página</span>,
                      rowsPerPageOptions: [50, 100],
                    }}
                    positionPagination='top'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableRowExpansion={true}
                    enableDensityToggle={false}
                    enableColumnFilters={true}
                    muiTableHeadCellProps={{
                      sx: denseHeadCellSx,
                    }}
                    renderTopToolbarCustomActions={() => {
                      if ([1, 2, 3, 141, this.props.project?.pf_id_coordenador].includes(user.pf_id)) {
                        return (
                          <Box marginLeft="auto">
                            <IconButton>
                              <ModalAddContaAPagar
                                {...this.props}
                                proj_id={this.props.proj_id}
                                user={user}
                                preloading={this.preloading}
                                getOneBdroRecord={this.getOneBdroRecord}
                              />
                            </IconButton>
                          </Box>
                        )
                      } else {
                        return null;
                      }
                    }}
                  />
                </TabPanel>
              </Tabs>
              <Modal
                open={this.state.openErrorModal}
                onClose={this.handleCloseErrorModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: 500,
                  bgcolor: 'background.paper',
                  border: '2px solid #000',
                  boxShadow: 24,
                  p: 4,
                }}>
                  <Typography id="modal-modal-title" variant="h6" component="h2">
                    Favor preencher todos os campos
                  </Typography>
                  <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    <p>Campos vazios no borderô {this.state.bdroComErro?.bdro_desc}:</p>
                    {this.state.emptyValues.map((value, index) =>
                      (
                        <div key={index}>
                          <span>{this.convertValueToText(value)}</span>
                        </div>
                      )
                    )}
                  </Typography>
                  <Button onClick={this.handleCloseErrorModal}>Voltar</Button>
                </Box>
              </Modal>
              <ModalConfirmacao
                openModal={this.state.publishConfirmModalOpen}
                isLoading={this.state.publishModalLoading}
                onClosed={this.handleClosePublishModal}
                title='Enviar pagamentos'
                text='Tem certeza de que deseja mandar todos os pagamentos?'
                confirmButtonText='Confirmar'
                onConfirm={this.handleConfirmPublish}
              />
            </div> : ((this.props.proj_orcRubrId && user.pf_id !== this.props.project.pf_id_coordenador) && (user.perm_id !== 1 && user.perm_id !== 2 && user.perm_id !== 3)) ?
            <div className='p-5' style={this.props.proj_id ? {} : {marginTop: "100px"}}>
              <h1>Você não tem permissão para acessar esta página</h1>
            </div> : ((this.props.proj_orcRubrId && user.pf_id === this.props.project.pf_id_coordenador) || (user.perm_id === 1 || user.perm_id === 2 || user.perm_id === 3)) &&
            <div style={this.props.proj_id ? {} : {marginTop: "100px"}}>
              <Tabs>
                <TabList>
                  <Tab>Solicitações ({dataNaoPendVisivel.length})</Tab>
                  <Tab>Pendentes ({dataPendVisivel.length})</Tab>
                  {toggleCartao}
                </TabList>
                <TabPanel>
                  <MaterialReactTable
                    columns={columns}
                    data={dataNaoPendVisivel}
                    initialState={{
                      density: 'compact',
                      grouping: ['bdro_dtVenc'],
                      expanded: {}, // dias começam colapsados
                      pagination: { pageIndex: 0, pageSize: 50 },
                      sorting: [{ id: 'bdro_dtVenc', desc: true }], //sort by state by default
                    }}
                    filterFns={{
                      dateRangeFilterFn: (row, id, filterValue) => {

                        if (!filterValue || !filterValue[0] || !filterValue[1]) {
                          return true; // Return true to show all rows if the filter is cleared
                        }

                        return ((row.getValue(id) >= (new Date(filterValue[0])).getTime()) && (row.getValue(id) <= (new Date(filterValue[1])).getTime()))
                      },
                    }}
                    enableFacetedValues

                    enableGrouping
                    {...bdroDndTableProps}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    enablePagination={(dataNaoPendVisivel.length > 50)}
                    muiTopToolbarProps={{sx: {
                      '.MuiButton-root .MuiSvgIcon-root': {width: "20px"},
                      '.MuiBox-root': {marginTop: "10px", height: "fit-content", display: "flex", alignItems: "center"},
                      '.MuiSvgIcon-root': {width: '12px'},
                      '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'},
                      '.MuiTablePagination-root .MuiToolbar-root': {minHeight: "30px !important", height: "30px !important"},
                      '.MuiTablePagination-root': {minHeight: "30px !important", height: "30px !important", marginTop: "2.3rem"},
                    }}}
                    muiTableBodyCellProps={{sx: denseBodyCellSx}}
                    muiTableContainerProps={{ sx: { maxWidth: '100%', overflowX: 'auto' } }}
                    /*
                    */
                    tableInstanceRef={this.tableRef}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Contas por página</span>,
                      rowsPerPageOptions: [50, 100],
                    }}
                    positionPagination='top'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableRowExpansion={true}
                    enableDensityToggle={false}
                    enableColumnFilters={true}
                    muiTableHeadCellProps={{
                      sx: denseHeadCellSx,
                    }}
                    renderTopToolbarCustomActions={() => {
                      if ([1, 2, 3, 141, this.props.project?.pf_id_coordenador].includes(user.pf_id)) {
                        return (
                          <Box marginLeft="auto">
                            <IconButton>
                              <ModalAddContaAPagar
                                {...this.props}
                                proj_id={this.props.proj_id}
                                proj_orcRubrId={this.props.proj_orcRubrId}
                                getOneBdroRecord={this.getOneBdroRecord}
                                user={user}
                                preloading={this.preloading}
                              />
                            </IconButton>
                          </Box>
                        )
                      } else {
                        return null;
                      }
                    }}
                  />
                </TabPanel>
                <TabPanel>
                  <MaterialReactTable
                    columns={columns}
                    data={dataPendVisivel}
                    initialState={{
                      density: 'compact',
                      grouping: ['bdro_dtVenc'],
                      expanded: {}, // dias começam colapsados
                      pagination: { pageIndex: 0, pageSize: 50 },
                      sorting: [{ id: 'bdro_dtVenc', desc: false }], //sort by state by default
                    }}
                    filterFns={{
                      dateRangeFilterFn: (row, id, filterValue) => {

                        if (!filterValue || !filterValue[0] || !filterValue[1]) {
                          return true; // Return true to show all rows if the filter is cleared
                        }

                        return ((row.getValue(id) >= (new Date(filterValue[0])).getTime()) && (row.getValue(id) <= (new Date(filterValue[1])).getTime()))
                      },
                    }}
                    enableFacetedValues
                    enableGrouping
                    {...bdroDndTableProps}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    enablePagination={(dataPendVisivel.length > 50)}
                    muiTopToolbarProps={{sx: {
                      '.MuiButton-root .MuiSvgIcon-root': {width: "20px"},
                      '.MuiBox-root': {marginTop: "10px", height: "fit-content", display: "flex", alignItems: "center"},
                      '.MuiSvgIcon-root': {marginBottom: "20px", width: '12px'},
                      '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'},
                      '.MuiTablePagination-root .MuiToolbar-root': {minHeight: "30px !important", height: "30px !important"},
                      '.MuiTablePagination-root': {minHeight: "30px !important", height: "30px !important", marginTop: "2.3rem"},
                    }}}

                    muiTableBodyCellProps={{sx: denseBodyCellSx}}
                    muiTableContainerProps={{ sx: { maxWidth: '100%', overflowX: 'auto' } }}
                    /*
                    */
                    tableInstanceRef={this.tableRef}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Contas por página</span>,
                      rowsPerPageOptions: [50, 100],
                    }}
                    positionPagination='top'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableRowExpansion={true}
                    enableDensityToggle={false}
                    enableColumnFilters={true}
                    muiTableHeadCellProps={{
                      sx: denseHeadCellSx,
                    }}
                    renderTopToolbarCustomActions={() => {
                      if ([1, 2, 3, 141, this.props.project?.pf_id_coordenador].includes(user.pf_id)) {
                        return (
                          <Box marginLeft="auto">
                            <IconButton>
                              <ModalAddContaAPagar
                                {...this.props}
                                proj_id={this.props.proj_id}
                                proj_orcRubrId={this.props.proj_orcRubrId}
                                user={user}
                                preloading={this.preloading}
                                getOneBdroRecord={this.getOneBdroRecord}
                              />
                            </IconButton>
                          </Box>
                        )
                      } else {
                        return null;
                      }
                    }}
                  />
                </TabPanel>
              </Tabs>
              <Modal
                open={this.state.openErrorModal}
                onClose={this.handleCloseErrorModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: 500,
                  bgcolor: 'background.paper',
                  border: '2px solid #000',
                  boxShadow: 24,
                  p: 4,
                }}>
                  <Typography id="modal-modal-title" variant="h6" component="h2">
                    Favor preencher todos os campos
                  </Typography>
                  <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    <p>Campos vazios no borderô {this.state.bdroComErro?.bdro_desc}:</p>
                    {this.state.emptyValues.map((value, index) =>
                      (
                        <div key={index}>
                          <span>{this.convertValueToText(value.campoComErro)}</span>
                        </div>
                      )
                    )}
                  </Typography>
                  <Button onClick={this.handleCloseErrorModal}>Voltar</Button>
                </Box>
              </Modal>
              <ModalConfirmacao
                openModal={this.state.salvarAnexoModalIsOpen}
                onClosed={()=>this.setState({ salvarAnexoModalIsOpen: false, pendingNotaFiscalFile: null })}
                title={`Salvar o documento ${this.state.pendingNotaFiscalFile && this.state.pendingNotaFiscalFile[0]?.data.path} como Nota Fiscal?`}
                subtitle={`Essa ação será irreversível.`}
                confirmButtonText='Confirmar'
                onConfirm={()=>{ this.setState({ notaFiscalFile: this.state.pendingNotaFiscalFile, pendingNotaFiscalFile: null, salvarAnexoModalIsOpen: false }) }}
              />
              <ModalConfirmacao
                openModal={this.state.publishConfirmModalOpen}
                isLoading={this.state.publishModalLoading}
                onClosed={this.handleClosePublishModal}
                title='Enviar pagamentos'
                text='Tem certeza de que deseja mandar todos os pagamentos?'
                confirmButtonText='Confirmar'
                onConfirm={this.handleConfirmPublish}
              />
            </div>
          }
        </>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({ auth: state.auth, technicalDep: state.technicalDep })
const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Bordero)
